<template>
  <div>
    <LoadingIndicator v-if="!news" />
    <h2 class="font-color-primary">
      {{ $t('general.news') }}
    </h2>
    <div class="grid-container py-3">
      <div
        v-for="item in news"
        :key="item.uri"
        class="item-card mx-2 my-2 el-card shadow p-2 py-3"
        @click="openLink('https://viacor.de/' + item.uri)"
      >
        <div>{{ item.publishedon }}</div>
        <div class="font-weight-bold">
          {{ item.pagetitle }}
        </div>
        <el-divider />
        <div class="mt-3 font-weight-light" v-html="item.introtext" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import StoreModules from '../../store/store-modules';
import LoadingIndicator from '../../components/loading/LoadingIndicator';
import { Plugins } from '@capacitor/core';
const { Browser } = Plugins;
export default {
  name: 'News',
  components: { LoadingIndicator },
  props: {},
  mounted() {
    this.loadNews();
  },
  destroyed() {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters(StoreModules.NEWS, ['news', 'isLoading']),
  },
  methods: {
    ...mapActions(StoreModules.NEWS, ['loadNews']),
    openLink(link) {
      Browser.open({ url: link });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/colors.scss';
.news-container {
  display: grid;
  grid-gap: 10px;
  grid-template-columns: auto auto auto;
}
</style>
